import ID from '../../../_helpers/uuid';

export const misc = () => {
    return {
        defaultUserCertificateFormElements: [
            {
                data: [],
                id: ID.uuid(),
                key: 'Header',
                fieldName: 'Certificate Form',
                type: 'textbox',
                instruction: '#Note: Submit this form in staff channel.',
            },
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'DateTimePicker',
                fieldName: 'Course Taken Date',
                type: 'datetime',
                instruction: '',
                config: {
                    specialityKey: 'courseTakenAt',
                },
                specialityKey: 'courseTakenAt',
            },
            {
                id: ID.uuid(),
                key: 'File',
                fieldName: 'Training Certificate',
                type: 'file',
                config: {
                    specialityKey: 'certificateUrl',
                },
                instruction: 'Supported Formats: Pdf and Image',
                specialityKey: 'certificateUrl',
            },
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Course Name',
                type: 'textbox',
                instruction: '',
                config: {
                    specialityKey: 'courseName',
                },
                specialityKey: 'courseName',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Course URL',
                type: 'textbox',
                instruction: '',
                config: {
                    specialityKey: 'courseUrl',
                },
                specialityKey: 'courseUrl',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Trainer',
                type: 'textbox',
                instruction: '',
                config: {
                    specialityKey: 'trainer',
                },
                specialityKey: 'trainer',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Training Objectives',
                type: 'textbox',
                instruction: '',
                config: {
                    specialityKey: 'trainingObjectives',
                },
                specialityKey: 'trainingObjectives',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Training Hours',
                type: 'textbox',
                instruction: '',
                config: {
                    specialityKey: 'trainingHours',
                },
                specialityKey: 'trainingHours',
            },
            {
                required: false,
                data: [
                    { text: '', value: '' },
                    { text: 'CESP', value: 'CESP' },
                    { text: 'ACRE', value: 'ACRE' },
                    { text: 'Dual Diagnosis', value: 'Dual Diagnosis' },
                    { text: 'SPeCTRUM 2.0', value: 'SPeCTRUM 2.0' },
                    { text: 'QM 101', value: 'QM 101' },
                    { text: 'QM 102 P1', value: 'QM 102 P1' },
                    { text: 'QM 102 P2', value: 'QM 102 P2' },
                    { text: 'QM 103', value: 'QM 103' },
                    { text: 'QMAP', value: 'QMAP' },
                    { text: 'CPR', value: 'CPR' },
                    { text: 'First Aid', value: 'First Aid' },
                ],
                id: ID.uuid(),
                key: 'Select',
                fieldName: 'Certificate Type',
                type: 'select',
                instruction: 'Select the certificate/course type',
                config: {
                    specialityKey: 'certificateType',
                },
                fieldProperties: {
                    useTitleAsValue: true,
                },
                specialityKey: 'certificateType',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'DatePicker',
                fieldName: 'Expiration Date',
                type: 'datetime',
                instruction: 'When does this certificate expire?',
                config: {
                    specialityKey: 'courseExpiresAt',
                },
                specialityKey: 'courseExpiresAt',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Renewal Link',
                type: 'textbox',
                instruction: 'URL to renew this certificate',
                config: {
                    specialityKey: 'courseRenewalLink',
                },
                specialityKey: 'courseRenewalLink',
            },
        ],
        defaultJobPostRawFormElements: [
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Job Post Text',
                type: 'textbox',
                instruction: 'Paste the full job description or posting text here.',
                specialityKey: 'rawJobText',
            },
        ],
        defaultJobPostFormElements: [
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Job Title',
                type: 'textbox',
                instruction: 'Enter a short, clear title (e.g., Direct Support Professional)',
                specialityKey: 'jobTitle',
            },
            {
                required: true,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Company Name',
                type: 'textbox',
                instruction: 'Name of the employer or agency.',
                specialityKey: 'companyName',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Location',
                type: 'textbox',
                instruction: 'City, state, or remote.',
                specialityKey: 'location',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Summary',
                type: 'textbox',
                instruction: 'Short summary of the role.',
                specialityKey: 'summary',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Responsibilities',
                type: 'textbox',
                instruction: 'Main responsibilities (bullets or sentences).',
                specialityKey: 'responsibilities',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Requirements',
                type: 'textbox',
                instruction: 'Key requirements (bullets or sentences).',
                specialityKey: 'requirements',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Skills',
                type: 'textbox',
                instruction: 'Key Skills (comma separated values)',
                specialityKey: 'skills',
            },
            {
                required: false,
                data: [],
                id: ID.uuid(),
                key: 'InputField',
                fieldName: 'Pay Range',
                type: 'textbox',
                instruction: 'e.g., $25–$35/hr or $60k–$80k',
                specialityKey: 'payRange',
            },
            {
                required: false,
                data: [
                    { text: 'Full-time', value: 'full-time' },
                    { text: 'Part-time', value: 'part-time' },
                    { text: 'Contract', value: 'contract' },
                    { text: 'Temporary', value: 'temporary' },
                    { text: 'Internship', value: 'internship' },
                ],
                id: ID.uuid(),
                key: 'Select',
                fieldName: 'Employment Type',
                type: 'select',
                instruction: '',
                specialityKey: 'employmentType',
            },
        ],
    };
};
